<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">PELARASAN GAJI SSPA - FASA 1</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="Amaun Dalam Buku Servis" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="3"> Amaun Dalam Buku Servis </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-input id="AmaunTelahTerima" v-model="Obj.AmaunTelahTerima" :state="getValidation(validationContext)"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Status SSPA " :rules="{ required: true }">
                    <b-row class="my-1">
                        <b-col sm="3">Memilih Sistem Saraan Perkhidmatan Awam (SSPA)</b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-group label-class="font-weight-bold">
                                <!-- YA 1 -->
                                <b-form-radio v-model="Obj.SSPAStatus" name="SSPAStatusRadios" :value="2">
                                    <b>YA (Memenuhi Syarat Mengikut PP1/2024)</b>
                                </b-form-radio>

                                <!-- YA 2 - teks panjang -->
                                <b-form-radio v-model="Obj.SSPAStatus" name="SSPAStatusRadios" @change="runMethod()" :value="3" class="mt-3">
                                    <div>
                                        <b> YA (Tidak Memenuhi Syarat Mengikut PP1/2024)</b><br>

                                        <div style="font-size:14px; margin-top:4px;">
                                            [Gred yang terlibat adalah seperti berikut :] <br>
                                            i. &nbsp; Gred G 11, G14;<br>
                                            ii. &nbsp; Gred H11, H14, H16, H18;<br>
                                            iii. &nbsp; Gred KP11, KP14, KP16, KP18;<br>
                                            iv. &nbsp; Gred N11, N14, N16, N18;<br>
                                            v. &nbsp; Gred U11, U14, U16, U18
                                        </div>
                                    </div>
                                </b-form-radio>

                                <!-- TIDAK -->
                                <b-form-radio v-model="Obj.SSPAStatus" name="SSPAStatusRadios" :value="1" class="mt-3">
                                    <b>TIDAK</b>
                                </b-form-radio>

                            </b-form-group>

                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <!-- <div v-if="Obj.SSPAStatus == 2">
                <validation-provider name="GredSemasa " :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="3">Pilihan Gred Gaji Semasa (SSM)</b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio v-model="Obj.GredSemasa" :aria-describedby="ariaDescribedby" name="GredSemasaRadios" 
                                value="1" :state="getValidation(validationContext)">Gred Permulaan Terendah (Gred 11 Sahaja)</b-form-radio>
                                <b-form-radio v-model="Obj.GredSemasa" :aria-describedby="ariaDescribedby" name="GredSemasaRadios" 
                                value="2" :state="getValidation(validationContext)">Selain Gred 11</b-form-radio>
                                <b-form-radio v-model="Obj.GredSemasa" :aria-describedby="ariaDescribedby" name="GredSemasaRadios" 
                                value="3" :state="getValidation(validationContext)">PENGURUSAN TERTINGGI</b-form-radio>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </validation-provider>
                </div> -->
                <br />

                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="3"> Catatan </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="8">
                            <!-- <b-form-input v-model="Obj.Catatan" :state="getValidation(validationContext)" class="custom-input"></b-form-input> -->
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" :state="getValidation(validationContext)" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit" :disabled="invalid">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun"],
    data() {
        return {
            Obj: {
                SSPAStatus: 2,
                AmaunTelahTerima: 0.00,
                Catatan: `Pelarasan Gaji SSPA Fasa 1. 
Pemberian <PERATUS>% kepada Kumpulan Pengurusan dan Professional serta Pelaksana dan Sokongan`,
            },
            StatusSimpan: {},
        };
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        runMethod() {
            swal
                .fire({
                    title: "SILA MASUKKAN TARIKH CUKUP SYARAT DI RUANG CATATAN!",
                    text: "KLIK OK UNTUK TERUSKAN.",
                    icon: "success",
                });

        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            console.log("logasda", this.Obj);
            this.Obj.elemenId = 24,

                GetsalaryService.simpan_elemenSSPAF1(this.Obj).then((resp) => {
                    this.StatusSimpan = resp.data;
                }).then(() => {

                    console.log("StatusSimpan", this.StatusSimpan);

                    if (this.StatusSimpan.Status == 1) {
                        swal
                            .fire({
                                title: "BERJAYA DI SIMPAN!",
                                text: "KLIK OK UNTUK TERUSKAN.",
                                icon: "success",
                            })
                            .then(() => {
                                this.$emit("batal");
                            });
                    } else {
                        swal.fire({
                            title: this.StatusSimpan.details,
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "error",
                        }).then(() => {
                            this.$emit("batal");
                        });
                    }
                });
        }
    },
    computed: {
        coid() {
            return Store.state.MaklumatPeribadi[0].coid;
        }
    },
    created() {
        // this.Obj = Store.state.MaklumatPeribadi;

    }
};
</script>

<style scoped>
.custom-input-large {
    font-size: 1.25rem;
    /* Atur ukuran font lebih besar */
    padding: .75rem 1.5rem;
    /* Sesuaikan padding input */
    height: auto;
    /* Sesuaikan tinggi input */
}
</style>
